export type ConciergeMenuCard = {
  index: number;
  label: string;
};

export function parseConciergeMenuCards(text: string): ConciergeMenuCard[] {
  const bounded = text.slice(0, 4000);
  const cards: ConciergeMenuCard[] = [];
  const seen = new Set<number>();
  for (const rawLine of bounded.split('\n')) {
    const line = rawLine.trim().slice(0, 80);
    const parsed = parseNumberedLine(line);
    if (!parsed || seen.has(parsed.index)) {
      continue;
    }
    seen.add(parsed.index);
    cards.push(parsed);
    if (cards.length >= 20) {
      break;
    }
  }
  return cards;
}

function parseNumberedLine(line: string): ConciergeMenuCard | null {
  const dot = line.indexOf('.');
  if (dot < 1 || dot > 2) {
    return null;
  }
  const indexPart = line.slice(0, dot);
  let value = 0;
  for (const ch of indexPart) {
    if (ch < '0' || ch > '9') {
      return null;
    }
    value = value * 10 + (ch.charCodeAt(0) - 48);
  }
  if (value < 1 || value > 20) {
    return null;
  }
  const label = line.slice(dot + 1).trim().slice(0, 24);
  if (!label) {
    return null;
  }
  return { index: value, label };
}
